module.exports = __webpack_public_path__ + "static/index/img/baikal-106.4fb9a9e2.jpg";